// Retain system text enlargement on phones while bounding measurements in
// keyboard-aware and fixed-height native layouts. Individual reading views can
// opt into unlimited scaling with maxFontSizeMultiplier={0}.
export const MOBILE_MAX_FONT_SIZE_MULTIPLIER = 2;
